<template>
  <SideBarLayoutContent full-width>
    <div class="mx-auto w-full max-w-4xl">
      <RouterView />
    </div>
  </SideBarLayoutContent>
</template>
<script lang="ts" setup>
  import SideBarLayoutContent from '@/core/components/layouts/SideBarLayoutContent.vue'
</script>
